// @flow
import PurchasesByPaymentMode from './PurchasesByPaymentMode';
import { dataKey } from './dataKey';


export default PurchasesByPaymentMode;
export { dataKey };
